import { State } from 'common/store/reducers';

export const selectUserData = (state: State) => state.userSettings.userForm.data;

export const selectUserDataLoading = (state: State) => state.userSettings.userForm.loading;

export const selectUserPatchLoading = (state: State) => state.userSettings.userForm.loadingUpdate;

export const selectUserPatchError = (state: State) => state.userSettings.userForm.error;
